import { Password, PasswordAutocompleteOptions, } from '@lightspeed/design-system-react';
import { useT } from '@transifex/react';
import { trackError } from '@vend/utilities';
import React, { useCallback, useEffect, useState } from 'react';
import { withTranslations } from '../../tx';
const isPasswordValid = (password, passwordStatus, repeatPassword) => {
    return password === repeatPassword && passwordStatus.isValid;
};
const NewPasswordUnconnected = ({ onPasswordChange: onValidPasswordChange, hasClickedSubmit, }) => {
    const t = useT();
    const [mainPassword, setMainPassword] = useState('');
    const [mainPasswordStatus, setMainPasswordStatus] = useState({
        isValid: false,
        validationResults: {
            hasMinimumLength: false,
            hasMinimumStrength: false,
        },
    });
    const [repeatPassword, setRepeatPassword] = useState('');
    const [repeatPasswordErrorMessage, setRepeatPasswordErrorMessage] = useState('');
    const [repeatPasswordTainted, setRepeatPasswordTainted] = useState(false);
    const updateRepeatError = useCallback((password, repeat) => {
        if (password !== repeat) {
            setRepeatPasswordErrorMessage(t('The passwords do not match'));
            return;
        }
        setRepeatPasswordErrorMessage('');
    }, [t]);
    useEffect(() => {
        if (hasClickedSubmit || repeatPasswordTainted) {
            updateRepeatError(mainPassword, repeatPassword);
        }
    }, [
        hasClickedSubmit,
        mainPassword,
        repeatPassword,
        repeatPasswordTainted,
        updateRepeatError,
    ]);
    // We call onValidPasswordChange in useEffect to ensure we have the latest state values
    // after React batches all state updates. This prevents a race condition when password
    // managers fill both fields simultaneously.
    useEffect(() => {
        onValidPasswordChange(mainPassword, isPasswordValid(mainPassword, mainPasswordStatus, repeatPassword));
    }, [mainPassword, mainPasswordStatus, repeatPassword, onValidPasswordChange]);
    const handlePasswordChange = (changedMainPassword, status) => {
        setMainPasswordStatus(status);
        setMainPassword(changedMainPassword);
        if (hasClickedSubmit || repeatPasswordTainted) {
            updateRepeatError(changedMainPassword, repeatPassword);
        }
    };
    const handleRepeatPasswordChange = (changedRepeatPassword) => {
        setRepeatPasswordTainted(true);
        setRepeatPassword(changedRepeatPassword);
        updateRepeatError(mainPassword, changedRepeatPassword);
    };
    return (React.createElement("div", null,
        React.createElement("div", { className: "vd-field" },
            React.createElement(Password, { label: t('New password', {
                    _context: 'new password component input lable',
                }), placeholder: t('Enter new password', {
                    _context: 'new password component input placeholder',
                }), autoComplete: PasswordAutocompleteOptions.NewPassword, onPasswordChange: handlePasswordChange, forceTaint: hasClickedSubmit, showStrengthMeter: true, showStrengthHints: true, enableZxcvbn: true, trackError: trackError })),
        React.createElement("div", { className: "vd-field" },
            React.createElement(Password
            // We don't check the minimum length on the repeat password input.
            , { 
                // We don't check the minimum length on the repeat password input.
                minimumLength: 0, label: t('Confirm password', {
                    _context: 'new password component input lable',
                }), autoComplete: PasswordAutocompleteOptions.NewPassword, placeholder: t('Enter new password again', {
                    _context: 'new password component input placeholder',
                }), onPasswordChange: handleRepeatPasswordChange, overriddenErrorMessage: repeatPasswordErrorMessage, forceTaint: hasClickedSubmit, enableZxcvbn: false }))));
};
export const NewPassword = withTranslations(NewPasswordUnconnected, 'NewPassword');
